import { ReactElement } from "react";
import * as React from "react";

import { AssetStatus } from "../../../generated/gql/graphql";
import useText from "../../../hooks/use-text";
import { LocalizedStrings, SupportedLanguages } from "../../../utils/lang";
import UserRole from "../../user-role/user-role";
import MetaSelect from "../parts/meta-select";

type Props = {
  error: boolean;
  onChangeStatus(status?: AssetStatus): void;
};

export default function StatusSelector(props: Props): ReactElement {
  const { error, onChangeStatus } = props;

  const { strings } = useText(local);
  const options = Object.keys(AssetStatus).map((t) => t);

  return (
    <UserRole>
      <MetaSelect
        error={error}
        required
        label={strings.label}
        name="value"
        getOptions={options}
        setOption={(v) => onChangeStatus(v["value"])}
        list={options.map((v) => ({ text: v, value: v }))}
      />
    </UserRole>
  );
}

type LocalSchema = {
  label: string;
};

const local: LocalizedStrings<LocalSchema, SupportedLanguages> = {
  default: {
    label: "Status",
  },
};
